module.exports = __webpack_public_path__ + "static/media/05.ddec676c.png";